import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'

import * as styles from './styles.module.scss'

const HeroImage = () => {
  return (
    <StaticImage
      className={styles.imageWrapper}
      src="./assets/interior.jpg"
      alt="Interior"
      placeholder="blurred"
      layout="fullWidth"
    />
  )}

export default HeroImage
